export default function PageHeader({ title, subtitle }) {
    return (
        <div className="page-header">
            <h2 className="page-header__title">{title}</h2>
            {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
    );
}
